class HeaderModule {
  constructor() {
    this.header = document.querySelector('.l-header');
    if (!this.header) return;

    this.trigger = this.header.querySelector('.l-header__menu');
    this.drawer = this.header.querySelector('#header-drawer');
    this.topVisibleY = 200;
    this.lastY = window.scrollY;

    this.init();
  }

  setHeaderVisible(visible) {
    this.header?.classList.toggle('is-header-visible', visible);
  }

  bindScroll() {
    this.setHeaderVisible(this.lastY <= this.topVisibleY);

    window.addEventListener(
      'scroll',
      () => {
        const currentY = window.scrollY;
        const isUp = currentY < this.lastY;

        if (!this.header.classList.contains('is-menu-open')) {
          this.setHeaderVisible(currentY <= this.topVisibleY || isUp);
        }

        this.lastY = currentY;
      },
      { passive: true },
    );
  }

  bindDrawer() {
    if (!this.trigger || !this.drawer) return;

    this.trigger.addEventListener('click', () => {
      const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
      this.trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      this.header.classList.toggle('is-menu-open', !isOpen);
      this.setHeaderVisible(true);
    });

    this.drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.header.classList.remove('is-menu-open');
      });
    });
  }

  init() {
    this.bindScroll();
    this.bindDrawer();
  }
}

export default HeaderModule;
